const Backbone = window.Backbone;
const featureManager = window.featureManager;

import TitleAuthorTemplate from '../../templates/TitleAuthor.html';

const TitleAuthor = Backbone.View.extend({
    template: TitleAuthorTemplate,

    className: 'title-author',

    tagName: 'div',

    initialize() {
        if (this.model.get('type').id !== 'periodicals') {
            this.render();
        }
    },

    render() {
        let title = this.model.toJSON();

        if (
            title.firstCreatorName != null &&
            !_.isEmpty(title.firstCreatorName)
        ) {
            const creatorName = title.firstCreatorName;

            const viewData = {
                href: window.url(window.routes.searchByType, {
                    type: 'creatorId',
                    query: title.firstCreatorId,
                    sortBy: 'newlyadded',
                }),
                label: window.text('cover.searchByAuthor', {
                    author: creatorName,
                }),
                text: creatorName,
                lang: this.model.languageCode,
                dir: this.model.dir,
            };

            this.$el.html(
                window.text('byLine', { creator: this.template(viewData) })
            );
        }
    },
});

export default TitleAuthor;
